<template>
  <!-- 实训中心 -->
  <div class="training">
    <gat-head
      class="training-head"
      @active-create="activeCreatePopup"
    ></gat-head>
    <div class="training-area">
      <div class="training-area-function">
        <div class="training-left">课程实训</div>
        <el-button
          class="add"
          type="primary"
          @click="activeCreatePopup"
          v-if="teacherOrStudentState"
        >
          <span class="icon"></span>
          创建课程实训
        </el-button>
        <search-box
          :placeholderName="'请输入课程实训名称'"
          :buttonShow="false"
          @onSearchKey="GetPageListByName"
        ></search-box>
      </div>

      <!-- 课程列表 -->
      <div class="no-content-list" v-if="trainingList && trainingList.length === 0">
        <img :src="emptyImgUrl" alt="">
        <span>{{searchKey ? '未检索到符合条件的课程实训' : (teacherOrStudentState ? '当前无课程实训，开始创建吧~' : '当前无课程实训')}}</span>
      </div>
      <div
        class="content-list"
        v-for="(item, index) in trainingList"
        :key="index"
      >
        <div
          class="content-list-title"
          @click="onCourseDetails(item.curriculumId)"
        >
          <div
            class="content-top-mark"
            v-if="
              userRole == 4
                ? item.isTop == 1
                : item.isTop == 1 && item.type != 1
            "
          ></div>
          <div class="content-list-img">
            <span
              :class="['content-item-type', item.type == 1 ? 'built-in' : '']"
              >{{ item.type == 1 ? '内置' : '精' }}</span
            >
            <img v-if="item.imgUrl" :src="photoBaseUrl + item.imgUrl" alt="" />
            <img v-else src="../../assets/images/video-bg.png" alt />
          </div>
          <div class="content-list-card">
            <div class="card-title">
              <span class="card-curriculumName" :title="item.curriculumName">{{item.curriculumName}}</span>
              <!-- <tooltip-box
                class="card-curriculumName"
                :textRef="'curriculumName'"
                :textId="item.curriculumId"
                :textRow="1"
                :textName="item.curriculumName"
                :placement="'top'"
                :tooltipShow="false"
              ></tooltip-box> -->
              <div class="edit-delete" v-if="teacherOrStudentState">
                <span
                  title="置顶"
                  :class="[
                    roleCourseShow(item.type) ? 'icon-top' : 'icon-top-grey',
                  ]"
                  @click.stop="activeTopPopup(item)"
                ></span>
                <i class="int"></i>
                <span
                  title="复制"
                  class="icon-copy"
                  @click.stop="activeCopyPopup(item)"
                ></span>
                <i class="int"></i>
                <span
                  title="编辑"
                  :class="[
                    roleCourseShow(item.type) ? 'icon-edit' : 'icon-edit-grey',
                  ]"
                  @click.stop="activeEditePopup(item)"
                ></span>
                <i class="int"></i>
                <span
                  title="删除"
                  :class="[
                    roleCourseShow(item.type)
                      ? 'icon-delete'
                      : 'icon-delete-grey',
                  ]"
                  @click.stop="activeDeletePopup(item)"
                ></span>
              </div>
              <div class="edit-delete" v-else>{{ item.createTime }}</div>
            </div>
            <div class="card-content" :title="item.curriculumContent">{{ item.curriculumContent }}</div>
            <!-- <tooltip-box
              class="card-content"
              :textRef="'curriculumContent'"
              :textId="item.curriculumId"
              :textRow="3"
              :textName="item.curriculumContent"
              :placement="'bottom'"
              :tooltipShow="false"
            ></tooltip-box> -->
            <div class="card-number">
              <span class="card-number-one">
                <img
                  :src="
                    item.photo
                      ? /^(https?:\/\/)/.test(item.photo)
                        ? item.photo
                        : photoBaseUrl + item.photo
                      : profile
                  "
                  alt
                />
                <p>
                  <i class="i-text" :title="item.createUserName">{{
                    item.createUserName
                  }}</i>
                  <i class="i-text" :title="item.roleName">{{
                    item.roleName
                  }}</i>
                  <i class="i-text" :title="item.orgsName">{{
                    item.orgsName
                  }}</i>
                </p>
              </span>
              <span class="card-number-two">
                <span class="icons el-icon-time"></span>
                {{ item.updateTime }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- 分页 -->
      <div class="pagination" v-show="trainingList && trainingList.length !== 0">
        <el-pagination
          @current-change="handleCurrentChange"
          background
          :current-page.sync="currentPage"
          :page-size="10"
          :pager-count="5"
          layout="slot, prev, pager, next"
          :total="totalCount"
        ></el-pagination>
      </div>
    </div>

    <div class="popup-list">
      <!-- 新建项目 | 编辑项目 -->
      <gat-popup
        :class="[
          'popup-create',
          popupActive === 'create' || popupActive === 'edit' ? 'on' : 'off',
        ]"
        :title="popup.title[popupActive]"
        :primary-button="popup.btnTxt[popupActive]"
        @cancel="cancelPopup"
        @confirm="projectEdite"
      >
        <template v-slot:content>
          <el-form
            class="pop-el-form"
            :model="NewProject"
            :rules="rules"
            ref="popupUploadForm"
          >
            <el-form-item prop="ProjectName">
              <div class="intxt">
                <span class="label"><i class="required">*</i>课程名称：</span>
                <el-input
                  placeholder="课程名称，必填项"
                  v-model.trim="NewProject.ProjectName"
                  maxlength="50"
                  show-word-limit
                />
              </div>
            </el-form-item>
            <el-form-item prop="">
              <div class="intxt">
                <span class="label"><i class="required">*</i>课程封面：</span>
                <div class="avatar-uploader">
                  <img
                    v-if="imageUrl"
                    :src="photoBaseUrl + imageUrl"
                    class="avatar"
                    @click="uploadPictures"
                  />
                  <div
                    v-else
                    class="avatar-uploader-icon"
                    @click="uploadPictures"
                  >
                    <div class="modify">
                      <span class="icon"></span>
                      <span class="modify-text">修改封面</span>
                    </div>
                  </div>
                </div>
                <!-- <el-alert
                  title="* 上传的封面只能为jpg格式"
                  type="error"
                ></el-alert> -->
              </div>
              <span class="icon-tips">* 上传的封面只能为jpg/jpeg格式</span>
            </el-form-item>
            <el-form-item prop="ProjectContent">
              <div class="intxt">
                <span class="label"><i class="required">*</i>课程描述：</span>
                <el-input
                  class="pop-textarea"
                  type="textarea"
                  placeholder="课程描述，必填项"
                  v-model.trim="NewProject.ProjectContent"
                  :rows="5"
                  maxlength="200"
                  show-word-limit
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item prop="" v-if="userRole == 4">
              <div class="form-switch">
                <span class="label"
                  ><i class="required">*</i>设置为系统内置课程：</span
                >
                <el-switch
                  v-model="NewProject.type"
                  :disabled="popupActive === 'edit'"
                >
                </el-switch>
              </div>
            </el-form-item>
          </el-form>
        </template>
      </gat-popup>

      <!-- 删除 -->
      <gat-popup
        :class="['popup-delete', popupActive === 'delete' ? 'on' : 'off']"
        :title="''"
        :primary-button="'删除'"
        @cancel="cancelPopup"
        @confirm="deleteProject"
      >
        <template v-slot:content>
          <div class="popup-del-cnt">
            <div class="head">
              <i class="icon-box">
                <icon-base
                  class="icon-info-help"
                  :icon-name="Icons.InfoHelp.iconName"
                  v-bind="Icons.InfoHelp"
                >
                  <icon-info-help class="path-icon-info-help" />
                </icon-base>
              </i>
              <!-- <span class="title">确定删除该课程实训吗？</span> -->
              <span class="title">{{ deleteTitle }}</span>
            </div>

            <div class="content">删除后可在 “回收站” 恢复哦</div>
          </div>
        </template>
      </gat-popup>

      <!-- 复制课程名称弹窗 -->
      <gat-popup
        :class="[
          'popup-create-copy',
          popupActive === 'createCopy' ? 'on' : 'off',
        ]"
        :title="'复制课程'"
        :primary-button="'确定'"
        @cancel="cancelPopup"
        @confirm="copyProject"
      >
        <template v-slot:content>
          <el-form
            class="pop-el-form"
            :model="NewCopyCourse"
            :rules="rulesCopyCourse"
            ref="popupCopyCourse"
          >
            <el-form-item prop="copyCourseName">
              <div class="intxt">
                <span class="label"><i class="required">*</i>课程名称：</span>
                <el-input
                  placeholder="请输入课程名称，必填项"
                  v-model.trim="NewCopyCourse.copyCourseName"
                  maxlength="50"
                  show-word-limit
                />
              </div>
            </el-form-item>
          </el-form>
        </template>
      </gat-popup>
    </div>
    <guide-tool path="training-center"></guide-tool>
  </div>
</template>

<script>
// api
import COMMON from '@/axios/common/common.js'
import PROJECTS from '@/axios/trainingCenter/projects/projects.js'
import GatPopup from '@/components/common/GatPopup'
import IconInfoHelp from '@/components/icons/typography/InfoHelp'
import SearchBox from '@/components/common/SearchBox.vue'
import GuideTool from '@/components/guide/GuideTool.vue'
import TooltipBox from '@/components/common/TooltipBox'
import { DictType } from '@/assets/js/mixin/mixin.js'
import { GetVerifyImgs } from '@/assets/js/mixin/mixinGetVerifyImgs.js'

export default {
  name: 'my-project',
  mixins: [DictType, GetVerifyImgs],
  components: { GatPopup, IconInfoHelp, SearchBox, GuideTool, TooltipBox },
  data() {
    return {
      userRole: 2, // 角色： 2-学生、1-老师、3-校管理员、4-超级管理员
      photoBaseUrl: window.gtaAiConfig.photoDomain, // 资源平台上传基地址
      imageUrl: '',
      teacherOrStudentState: false, // 用户身份(老师-true / 学生-false)
      currentPage: 1,
      totalCount: 0,
      NewProject: {
        ProjectName: '',
        ProjectContent: '',
        type: true,
      },
      rules: {
        ProjectName: [{ required: true, message: '请填写课程名称' }],
        ProjectContent: [{ required: true, message: '请填写课程描述' }],
        // ProType: [{ required: true, message: "请选择课程类型" }]
      },
      popupActive: '',
      popup: {
        title: {
          edit: '编辑课程实训',
          create: '创建课程实训',
        },
        btnTxt: {
          edit: '确定',
          create: '新建',
        },
      },
      deleteTitle: '确定删除该课程实训吗？',
      searchKey: '',
      Icons: {
        InfoHelp: {
          iconName: '',
          viewBox: '0 0 36 36',
          width: '36',
          height: '36',
          // iconColor: "#fff"
        },
      },
      trainingList: [], // 课程集合
      projectTypeArr: [],
      copyCourse: {},
      NewCopyCourse: {
        copyCourseName: '',
      },
      rulesCopyCourse: {
        copyCourseName: [{ required: true, message: '请填写课程名称' }],
      },
      profile: require('../../../public/images/profile03.png'),
      emptyImgUrl: require('../../assets/images/datasetLobby/icon-empty-box.png'),
      fullscreenLoading: null, // 加载效果
    }
  },
  computed: {
    token() {
      return this.$store.state.token
    },
  },
  watch: {
    token() {
      this.getMyProjectList()
    },
    'NewProject.ProType'(typeId) {
      if (!typeId) {
        return
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    // 获取路由来源
    next((vm) => {
      if (to.params.operate === 'create' && from.name) vm.activeCreatePopup()
    })
  },
  created() {
    this.projectTypeArr = this.$store.state.projectTypeArr // 获取行业类型
    // 获取用户身份（老师/学生/管理员）
    this.userRole = this.$store.state.userRole
    if (this.userRole == 2) {
      // 学生
      this.teacherOrStudentState = false
      this.getMyProjectList()
    } else {
      // 老师、管理员、超级管理员
      this.teacherOrStudentState = true
      this.getMyProjectList()
    }
  },
  mounted() {},
  methods: {
    // 内置课程&&角色-权限处理
    roleCourseShow(type) {
      if (type == 1) {
        // 内置课程
        return this.userRole == 4 ? true : false // 4-超级管理员
      } else {
        // 精品课程
        return this.userRole == 2 ? false : true // 2-学生
      }
    },
    // 上传图片
    uploadPictures() {
      var uploadFileNode = document.createElement('input') // 创建上传按钮
      var fileList = [] // 文件列表
      var self = this

      uploadFileNode.setAttribute('type', 'file') // 设置上传按钮属性
      uploadFileNode.setAttribute('multiple', 'ture') // 多文件上传
      uploadFileNode.setAttribute('accept', 'image/jpeg, image/jpg') // 限制图片上传
      // uploadFileNode.setAttribute('accept', 'image/*') // 限制图片上传
      // uploadFileNode.setAttribute("enctype", "multipart/form-data;"); // 编码方式

      uploadFileNode.click() // 触发上传事件

      // 上传进程
      uploadFileNode.onchange = function uploadChange(evt) {
        var formdata = new FormData(),
          list,
          formatPass = true

        // 文件装配
        fileList = evt.target.files
        list = Array.from(fileList)

        // 如果存在不是 image/jpeg 格式的图片就会触发停止上传的操作
        // jpg/jpeg 是一样，同属于 image/jpeg 格式
        formatPass = self.$util.filesFormatCheck(list, 'jpg|jpeg')

        if (formatPass) {
          return self.$message.error('上传失败，只允许上传 jpg/jpeg 格式图片！')
        }

        list.forEach((file) => {
          formdata.append('file', file, file.name)
        })

        let fullscreenLoading = self.$loading({
          lock: true,
          text: `图片上传中请稍等...`,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        COMMON.UploadMultipleFile(formdata).then((result) => {
          if (result.returnCode == 200) {
            let imgList = result.data;
            if (imgList.length === 0) {
              return fullscreenLoading.close(); // 关闭Loading
            }
            // 校验图片jpg|jpeg
            self.verifyImgs(imgList).then(res => {
              if (res.correct && res.correct.length) {
                self.imageUrl = imgList[0].url
              }
            })
            fullscreenLoading.close(); // 关闭Loading
          } else {
            fullscreenLoading.close(); // 关闭Loading
          }
        }).catch(err => {
          console.log('error', err)
          fullscreenLoading.close(); // 关闭Loading
        });
      }
    },

    // 查询课程列表
    getMyProjectList(pageIdx) {
      let params = {
        curriculumName: this.searchKey,
        pageNum: pageIdx || 1,
        pageSize: 10,
      }
      if (this.teacherOrStudentState) {
        // 获取我的项目列表(老师/管理员/超级管理员)
        PROJECTS.getMyProjectList(params).then((result) => {
          if (result.returnCode === 200) {
            if (result.data && result.data.records) {
              this.trainingList = result.data.records
              this.totalCount = result.data.total
              this.currentPage = result.data.current
            }
          }
        })
      } else {
        // 获取我的项目列表（学生）
        PROJECTS.getProjectListByStudentId(params).then((result) => {
          if (result.returnCode === 200) {
            if (result.data && result.data.records) {
              this.trainingList = result.data.records
              this.totalCount = result.data.total
              this.currentPage = result.data.current
            }
          }
        })
      }
    },
    onCourseDetails(curriculumId) {
      this.$router.push({
        name: 'course-details',
        query: { curriculumId: curriculumId },
      })
    },
    // 搜索获取项目分页
    GetPageListByName(key) {
      this.searchKey = key
      this.getMyProjectList(1)
    },
    // 取消弹窗
    cancelPopup() {
      if (
        this.popupActive === 'create' ||
        this.popupActive === 'edit' ||
        this.popupActive === 'delete'
      ) {
        this.NewProject = {
          ProjectName: '',
          ProjectContent: '',
          type: true,
        }
        this.imageUrl = ''
        this.$refs.popupUploadForm.resetFields()
      }

      if (this.popupActive === 'createCopy') {
        this.NewCopyCourse.copyCourseName = ''
        this.$refs.popupCopyCourse.resetFields()
      }

      this.popupActive = ''
    },
    // 置顶实训课程
    activeTopPopup(val) {
      let roleCourseShow = !this.roleCourseShow(val.type) // 内置课程&&角色-权限处理
      if (roleCourseShow) {
        return
      }

      let params = {
        curriculumId: val.curriculumId,
        type: val.type,
      }
      PROJECTS.topCurriculum(params).then((result) => {
        if (result.isSuccess) {
          this.$message.success(result.returnMsg)
          // this.currentPage = 1
          this.getMyProjectList(1)
        } else {
          this.$message.error(result.returnMsg)
        }
      })
    },
    // 复制实训课程
    activeCopyPopup(val) {
      this.popupActive = 'createCopy'
      this.copyCourse = val
      this.NewCopyCourse.copyCourseName = val.curriculumName
    },
    // 确认复制实训课程
    copyProject() {
      this.$refs.popupCopyCourse.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '复制中请稍等...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
          })
          setTimeout(() => {
            loading.close()
          }, 1000 * 30)

          let params = {
            type: this.copyCourse.type,
            curriculumId: this.copyCourse.curriculumId,
            curriculumName: this.NewCopyCourse.copyCourseName,
          }
          PROJECTS.copyCurriculum(params)
            .then((result) => {
              if (result.isSuccess) {
                this.$message.success(result.returnMsg)
                this.getMyProjectList(1)
                this.cancelPopup()
                loading.close()
              } else {
                this.$message.error(result.returnMsg)
                loading.close()
              }
            })
            .catch(() => {
              loading.close()
            })
        } else {
          // this.$message.error('请输入课程名称！')
        }
      })
    },
    // 新建项目
    activeCreatePopup() {
      this.popupActive = 'create'
    },
    // 新建项目
    createNewProject() {
      // 项目命名不能为空和超出限制的字符长度
      if (
        this.$util.checkStrNullOrTooLong.call(this, [
          this.NewProject.ProjectName,
        ])
      ) {
        return
      }

      if (!this.imageUrl) {
        return this.$message.error('请上传课程封面！')
      }

      let params = {
        curriculumContent: this.NewProject.ProjectContent,
        curriculumName: this.NewProject.ProjectName,
        imgUrl: this.imageUrl,
        type: 0, // 课程类型：0-精品课程，1-内置课程（只可超级管理员创建）。
      }
      if (this.userRole == 4) {
        params.type = this.NewProject.type ? 1 : 0
      }

      PROJECTS.insertCurriculum(params).then((result) => {
        if (result.isSuccess) {
          // 点击【马上创作】进来
          this.$message.success('项目新建成功！')
          this.getMyProjectList()
          this.cancelPopup()
        } else {
          // 项目名称重复，重新输入名称。
          this.$message({
            message: result.returnMsg || '创建失败',
            type: 'error',
            duration: 2000,
          })
        }
      })
    },
    // 编辑
    activeEditePopup(item) {
      let roleCourseShow = !this.roleCourseShow(item.type) // 内置课程&&角色-权限处理
      if (roleCourseShow) {
        return
      }
      this.NewProject.ProjectName = item.curriculumName // 项目名称
      this.NewProject.ProjectContent = item.curriculumContent // 项目内容
      this.NewProject.curriculumId = item.curriculumId // 课程ID
      this.imageUrl = item.imgUrl
      this.NewProject.ProjectId = item.id
      this.popupActive = 'edit'
      this.NewProject.type = item.type == 1 ? true : false
      // debugger
    },
    // 编辑项目
    editeProject() {
      // 项目命名不能为空和超出限制的字符长度
      if (
        this.$util.checkStrNullOrTooLong.call(this, [
          this.NewProject.ProjectName,
        ])
      ) {
        return
      }

      let params = {
        curriculumContent: this.NewProject.ProjectContent,
        curriculumName: this.NewProject.ProjectName,
        curriculumId: this.NewProject.curriculumId,
        imgUrl: this.imageUrl,
      }

      PROJECTS.updateCurriculum(params).then((result) => {
        if (result.isSuccess) {
          this.$message.success('成功编辑项目！')
          this.getMyProjectList(this.currentPage)
          this.cancelPopup()
        } else if (result.errorCode === 40101) {
          // 项目名称重复，重新输入名称。
          this.$message.error('项目名称重复，请重新输入名称！')
        } else {
          this.$message.error(result.returnMsg)
        }
      })
    },
    // 编辑项目，创建项目 + 编辑项目
    projectEdite() {
      this.$refs.popupUploadForm.validate((valid) => {
        if (valid) {
          if (this.popupActive === 'create') {
            // 新增
            this.createNewProject()
          } else if (this.popupActive === 'edit') {
            // 编辑
            this.editeProject()
          }
        } else {
          this.$message.error('请将项目相关内容填写完整')
        }
      })
    },
    // 删除项目
    activeDeletePopup(item) {
      let roleCourseShow = !this.roleCourseShow(item.type) // 内置课程&&角色-权限处理
      if (roleCourseShow) {
        return
      }
      this.NewProject = JSON.parse(JSON.stringify(item))
      // this.NewProject = item;
      this.NewProject.ProjectName = item.curriculumName // 项目名称
      this.NewProject.ProjectContent = item.curriculumContent // 项目内容
      this.imageUrl = item.imgUrl
      this.deleteTitle = '确定删除该课程实训吗？'
      this.popupActive = 'delete'
    },
    deleteProject() {
      // 删除项目
      let params = {
        curriculumName: this.NewProject.ProjectName,
        curriculumContent: this.NewProject.ProjectContent,
        imgUrl: this.imageUrl,
        curriculumId: this.NewProject.curriculumId, // 课程id
        type: this.NewProject.type, // 0表示精品课程，1表示内置课程
      }
      PROJECTS.deleteCurriculum(params).then((result) => {
        if (result.isSuccess) {
          this.$message.success('删除成功！')
          let page =
            this.trainingList.length <= 1 && this.currentPage > 1
              ? this.currentPage - 1
              : this.currentPage
          this.getMyProjectList(page)
          this.cancelPopup()
          this.$forceUpdate()
        } else {
          this.$message.error(result.returnMsg)
        }
      })
    },
    // 分页
    handleCurrentChange(pageIdx) {
      this.currentPage = pageIdx
      this.getMyProjectList(pageIdx)
    },
  },
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
}
</script>

<style lang="scss" scoped>
@import './TrainingProject';
</style>
